import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white p-4 rounded-lg mt-4 text-left text-textPrimary" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-md font-bold" }, "Jornada excepcional", -1)
const _hoisted_3 = { class: "flex flex-col gap-4 mt-4" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-md font-semibold mb-2" }, "Início", -1)
const _hoisted_6 = { class: "bg-white flex flex-row gap-2" }
const _hoisted_7 = { class: "flex flex-row items-center rounded border border-secondary50 gap-2 py-2 px-2 flex-1" }
const _hoisted_8 = ["min", "max"]
const _hoisted_9 = { class: "flex flex-row items-center rounded border border-secondary50 gap-2 py-2 px-2 flex-1" }
const _hoisted_10 = { class: "text-left" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "text-md font-semibold mb-2" }, "Fim", -1)
const _hoisted_12 = { class: "bg-white flex flex-row gap-2" }
const _hoisted_13 = { class: "flex flex-row items-center rounded border border-secondary50 gap-2 py-2 px-2 flex-1" }
const _hoisted_14 = ["min", "max"]
const _hoisted_15 = { class: "flex flex-row items-center rounded border border-secondary50 gap-2 py-2 px-2 flex-1" }
const _hoisted_16 = { class: "grid grid-cols-2 gap-4 mt-6" }
const _hoisted_17 = { class: "text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-bold" }, "Horas perdidas", -1)
const _hoisted_19 = { class: "mt-1 text-md text-negative" }

import { ref, watch, computed } from 'vue'
import { differenceInMinutes, format, formatDuration } from 'date-fns'
import { ptBR } from 'date-fns/locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExceptionalJourney',
  props: {
    modelValue: {},
    originalStart: {},
    originalEnd: {},
    baseHourlyRate: {},
    timezone: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props;





const splitDateTime = (isoString: string, timezone: string | undefined) => {
  if (!isoString) return { date: '', time: '' }
  const targetTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone

  try {
    const date = new Date(isoString)
    if (isNaN(date.getTime())) return { date: '', time: '' }

    const datePart = new Intl.DateTimeFormat('sv-SE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      timeZone: targetTimezone
    }).format(date)

    const timePart = new Intl.DateTimeFormat('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: targetTimezone
    }).format(date)

    return { date: datePart, time: timePart }
  } catch (e) {
    const fallbackDate = new Date(isoString)
    return {
      date: format(fallbackDate, 'yyyy-MM-dd'),
      time: format(fallbackDate, 'HH:mm')
    }
  }
}

const startDate = ref(splitDateTime(props.originalStart, props.timezone).date)
const startTime = ref(splitDateTime(props.originalStart, props.timezone).time)
const endDate = ref(splitDateTime(props.originalEnd, props.timezone).date)
const endTime = ref(splitDateTime(props.originalEnd, props.timezone).time)

const getDurationInMinutes = (startStr: string, endStr: string): number => {
  if (!startStr || !endStr) return 0
  const start = new Date(startStr)
  const end = new Date(endStr)

  if (isNaN(start.getTime()) || isNaN(end.getTime()) || end < start) return 0
  return differenceInMinutes(end, start)
}

const baseDurationInMinutes = computed(() =>
  getDurationInMinutes(props.originalStart, props.originalEnd)
)

const exceptionalDurationInMinutes = computed(() => {
  if (startDate.value && endDate.value) {
    const start = `${startDate.value}T${startTime.value || '00:00'}`
    const end = `${endDate.value}T${endTime.value || '00:00'}`
    return getDurationInMinutes(start, end)
  }
  return 0
})

const lostMinutes = computed(() => baseDurationInMinutes.value - exceptionalDurationInMinutes.value)

const lostHoursFormatted = computed(() => {
  if (lostMinutes.value <= 0) return '0 horas e 0 minutos'
  return formatDuration(
    {
      hours: Math.floor(lostMinutes.value / 60),
      minutes: lostMinutes.value % 60
    },
    { format: ['hours', 'minutes'], locale: ptBR }
  )
})

// const predictedLossFormatted = computed(() => {
//   if (lostMinutes.value <= 0)
//     return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(0)

//   const lostHours = lostMinutes.value / 60
//   const lossValue = lostHours * props.baseHourlyRate

//   return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(lossValue)
// })

watch([startDate, startTime, endDate, endTime], () => {
  if (startDate.value && endDate.value) {
    const fullStartDateTime = `${startDate.value}T${startTime.value || '00:00'}`
    const fullEndDateTime = `${endDate.value}T${endTime.value || '00:00'}`
    emit('update:modelValue', {
      start: fullStartDateTime,
      end: fullEndDateTime
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
              class: "bg-transparent focus:outline-none w-full text-sm",
              min: startDate.value,
              max: endDate.value
            }, null, 8, _hoisted_8), [
              [_vModelText, startDate.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              type: "time",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((startTime).value = $event)),
              class: "bg-transparent focus:outline-none w-full text-sm"
            }, null, 512), [
              [_vModelText, startTime.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((endDate).value = $event)),
              class: "bg-transparent focus:outline-none w-full text-sm",
              min: startDate.value,
              max: endDate.value
            }, null, 8, _hoisted_14), [
              [_vModelText, endDate.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "time",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((endTime).value = $event)),
              class: "bg-transparent focus:outline-none w-full text-sm"
            }, null, 512), [
              [_vModelText, endTime.value]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("p", _hoisted_19, _toDisplayString(lostHoursFormatted.value), 1)
      ])
    ])
  ]))
}
}

})